<template>
  <div>
    <!-- КАРТОЧКА КЛИЕНТА -->
    <template v-if="!detailedItem.is_transport_company">
        <div class="d-flex justify-content-between align-items-center mb-4">
            <h5 style="padding-left: 0.75rem" class="mb-0">Детали компании</h5>

            <div>
                <template v-if="detailedItem.status">
                    <b-badge 
                        :variant="detailedItem.reference_company_status_id == 370 ? 'danger':'secondary'"
                        class="px-2 py-2 text-uppercase"
                        title="Статус выставлен менеджером"
                    >
                        {{ detailedItem.status.name }}
                    </b-badge>
                </template>
                <template v-if="detailedItem.latest_dadata_check">
                    <b-badge 
                        :variant="detailedItem.latest_dadata_check.is_liquidated ? 'danger' : 'success'" 
                        class="px-2 py-2 ml-2 text-uppercase cursor-pointer"
                        title="Статус выставлен в ходе последней автоматической проверки из открытых источников"
                        @click="isOpenCheckDetails = !isOpenCheckDetails"
                    >
                        Авто проверка: {{ detailedItem.latest_dadata_check.is_liquidated ? 'Ликвидирована' : 'Активна' }}
                        <b-icon
                            :icon="!isOpenCheckDetails ? 'arrow-down-short':'arrow-up-short'"
                            scale="1"
                            aria-label="Раскрыть/Закрыть"
                        ></b-icon>                        
                    </b-badge>
                </template>
                <template v-if="String(detailedItem.inn).length < 10">
                    <b-badge 
                        variant="danger" 
                        class="px-2 py-2 ml-2 text-uppercase"
                        title="Статус выставлен в ходе последней автоматической проверки из открытых источников"
                    >
                        Ошибка ИНН
                    </b-badge>
                </template>
            </div>                
        </div>

        <template v-if="isOpenCheckDetails">
            <CompanyDadataCheckDetails
                :companyId="detailedItem.id"
                :isHideHeader="true"
            />
        </template>
  
      <div class="form-row">
        <div class="form-group col-md-6">
          <div class="details-group">
            <div class="value-of-field big-value-of-field">{{ detailedItem.name || "Не указано" }}</div>
            <div class="descr-of-field">Полное название компании</div>
          </div>

          <template v-if="detailedItem.is_b2c_rezident">
            <div class="details-group">
              <div class="value-of-field">
                <b-badge variant="info" class="px-2 py-1">Резидент B2C</b-badge>
              </div>
              <div class="descr-of-field">Компания является резидентом B2C</div>
            </div>
            <div class="details-group">
              <div class="value-of-field">{{ detailedItem.b2c_alias || "Краткое наименование отсутствует" }}</div>
              <div class="descr-of-field">Краткое наименование (B2C алиас)</div>
            </div>
          </template>

          <div class="details-group" v-if="detailedItem.bitrix_company_id">
            <div class="value-of-field">{{ detailedItem.bitrix_company_id }}</div>
            <div class="descr-of-field">ID компании в Битрикс 24</div>
          </div>

          <div class="details-group">
            <div class="value-of-field">{{ detailedItem.status ? detailedItem.status.name : "Не указано" }}</div>
            <div class="descr-of-field">Текущий статус компании</div>
          </div>

          <div class="details-group">
            <div class="value-of-field">{{ detailedItem.sales_status }}</div>
            <div class="descr-of-field">Статус продаж</div>
          </div>

          <div class="details-group" v-if="detailedItem.sales_status == 'Не готов'">
            <div class="value-of-field">{{ detailedItem.decline_type ? detailedItem.decline_type.name : "Не указано" }}</div>
            <div class="descr-of-field">Последний статус отказа</div>
          </div>

          <div class="details-group">
            <div class="value-of-field">{{ detailedItem.phones || "Не указано" }}</div>
            <div class="descr-of-field">Телефоны компании</div>
          </div>

          <div 
            v-if="detailedItem.bookmarked_comments && detailedItem.bookmarked_comments.length > 0"
            class="details-group bookmarked-comments-of-company"
          >
            <div class="value-of-field">
              <div v-for="item in detailedItem.bookmarked_comments" :key="item.id">
                <span v-html="cleanedComment(item.comment)"></span>
              </div>
            </div>
            <div class="descr-of-field">Отметки менеджеров о компании</div>
          </div>

          <div class="details-group">
            <div class="value-of-field">{{ detailedItem.seasonable ? seasonable_name : "Без сезонности" }}</div>
            <div class="descr-of-field">Сезонность</div>
          </div>

          <div class="details-group">
            <div class="value-of-field sm-value-of-field">{{ detailedItem.address || "Не указан" }}</div>
            <div class="descr-of-field">Юридический адрес</div>
          </div>

          <div class="details-group">
            <div class="value-of-field">{{ detailedItem.director || "Не указан" }}</div>
            <div class="descr-of-field">ФИО директора</div>
          </div>

          <div class="details-group">
            <div class="value-of-field">{{ detailedItem.type_director || "Не указан" }}</div>
            <div class="descr-of-field">В лице</div>
          </div>

          <div class="details-group">
            <div class="d-flex">
              <div class="mr-3">
                <div class="value-of-field">{{ detailedItem.inn || "Не указан" }}</div>
                <div class="descr-of-field">ИНН</div>
              </div>
              <div class="mr-3">
                <div class="value-of-field">{{ detailedItem.ogrn || "Не указан" }}</div>
                <div class="descr-of-field">ОГРН</div>
              </div>
              <div>
                <div class="value-of-field">{{ detailedItem.kpp || "Не указан" }}</div>
                <div class="descr-of-field">КПП</div>
              </div>
            </div>
          </div>

          <div class="details-group" v-if="canShowSubCompanies(detailedItem.parent)">
            <div class="value-of-field">
              <tree-view
                :items="detailedItem.parent"
                :item-children="'parent'"
              >
                <template #item="{ item }">
                  <span
                      class="sidebar-link"
                      @click="openCompanySidebar(item.id)"
                  >
                      {{ item.name }}
                  </span>
                </template>
              </tree-view>              
            </div>
            <div class="descr-of-field">Родительская компания</div>
          </div>

          <div class="details-group" v-if="canShowSubCompanies(detailedItem.children)">
            <div class="value-of-field">
              <tree-view
                :items="detailedItem.children"
              >
                <template #item="{ item }">
                  <span
                      class="sidebar-link"
                      @click="openCompanySidebar(item.id)"
                  >
                      {{ item.name }}
                  </span>
                </template>
              </tree-view>           
            </div>
            <div class="descr-of-field">Дочерние компании</div>
          </div>
        </div>

        <div class="form-group col-md-6 bg-gray-right">
          <div class="details-group">
            <div class="value-of-field">
              {{
                detailedItem.sales_manager
                  ? detailedItem.sales_manager.name
                  : "Не указан"
              }}
            </div>
            <div class="descr-of-field">Менеджер SALES</div>
          </div>

          <div class="details-group">
            <div class="value-of-field">
              {{
                detailedItem.to_manager
                  ? detailedItem.to_manager.name
                  : "Не указан"
              }}
            </div>
            <div class="descr-of-field">Менеджер по ведению ВЭД</div>
          </div>

          <div class="details-group">
            <div class="value-of-field">
              {{
                detailedItem.teo_manager
                  ? detailedItem.teo_manager.name
                  : "Не указан"
              }}
            </div>
            <div class="descr-of-field">Менеджер по ведению ТЭО</div>
          </div>

          <div class="details-group">
            <div class="value-of-field">{{ detailedItem.source ? detailedItem.source.name : "Не указан" }}</div>
            <div class="descr-of-field">Источник клиента</div>
          </div>

          <div class="details-group" v-if="!isAgent">
            <div class="value-of-field">{{ detailedItem.percent_of_mp_to_calc }}%</div>
            <div class="descr-of-field">Процент маржинальной прибыли, идущий в расчеты</div>
          </div>

          <div class="details-group" v-if="detailedItem.external_sales_manager_name && !isAgent">
            <div class="value-of-field">{{ detailedItem.external_sales_manager_name }}</div>
            <div class="descr-of-field">Клиента привёл</div>
          </div>
        </div>
      </div>
    </template>
    <!-- КАРТОЧКА ТРАНСПОРТНОЙ КОМПАНИИ -->
    <template v-if="detailedItem.is_transport_company">
      <div class="d-flex justify-content-start align-items-start">
        <div class="d-flex justify-content-between align-items-center mb-4">
            <h5 style="padding-left: 0.75rem;" class="mb-0">Детали компании</h5>
        </div>

        <div class="ml-2" style="margin-top: -2px;">
          <b-badge
            variant="secondary"
            class="always-small-badge"
          >Статус компании: {{ detailedItem.status ? detailedItem.status.name : "Не указано" }}</b-badge>
          <b-badge
            variant="success"
            class="always-small-badge"
            v-if="detailedItem.checked_id == 444"
            ><i class="bx bx-check"></i> Безопасность: Компания проверена!</b-badge
          >
          <b-badge
            variant="secondary"
            class="always-small-badge"
            v-if="detailedItem.checked_id == 443"
            >Безопасность: Компания на проверке</b-badge
          >
          <b-badge
            variant="danger"
            class="always-small-badge"
            v-if="detailedItem.checked_id == 445"
            >Безопасность: Компания не прошла проверку!</b-badge
          >
          <template v-if="detailedItem.latest_dadata_check">
            <b-badge 
                :variant="detailedItem.latest_dadata_check.is_liquidated ? 'danger' : 'success'" 
                class="always-small-badge cursor-pointer"
                title="Статус выставлен в ходе последней автоматической проверки из открытых источников"
                @click="isOpenCheckDetails = !isOpenCheckDetails"
            >
                Авто проверка: {{ detailedItem.latest_dadata_check.is_liquidated ? 'Ликвидирована' : 'Активна' }}
                <b-icon
                    :icon="!isOpenCheckDetails ? 'arrow-down-short':'arrow-up-short'"
                    scale="1"
                    aria-label="Раскрыть/Закрыть"
                ></b-icon>                        
            </b-badge>
          </template>
          <template v-if="String(detailedItem.inn).length < 10">
            <b-badge 
                variant="danger" 
                class="always-small-badge"
                title="Статус выставлен в ходе последней автоматической проверки из открытых источников"
            >
                Ошибка ИНН
            </b-badge>
          </template>          
        </div>
      </div>

      <template v-if="isOpenCheckDetails">
        <CompanyDadataCheckDetails
            :companyId="detailedItem.id"
            :isHideHeader="true"
        />
      </template>

      <div class="form-row">
        <div class="form-group col-md-6">
          <div class="details-group">
            <div class="value-of-field big-value-of-field">{{ detailedItem.name || "Не указано" }}</div>
            <div class="descr-of-field">Наименование поставщика</div>
          </div>

          <template v-if="detailedItem.is_b2c_rezident">
            <div class="details-group">
              <div class="value-of-field">
                <b-badge variant="info" class="px-2 py-1">Резидент B2C</b-badge>
              </div>
              <div class="descr-of-field">Компания является резидентом B2C</div>
            </div>
            <div class="details-group">
              <div class="value-of-field">{{ detailedItem.b2c_alias || "Краткое наименование отсутствует" }}</div>
              <div class="descr-of-field">Краткое наименование (B2C алиас)</div>
            </div>
          </template>

          <div class="details-group">
            <div class="value-of-field">{{ detailedItem.country.name || "Не указано" }}</div>
            <div class="descr-of-field">Страна регистрации</div>
          </div>

          <div class="details-group">
            <div class="value-of-field">{{ detailedItem.type_of_transport_company || "Не указано" }}</div>
            <div class="descr-of-field">Тип поставщика</div>
          </div>

          <div class="details-group">
            <div class="d-flex">
              <div class="mr-3">
                <div class="value-of-field">{{ detailedItem.inn || "Не указан" }}</div>
                <div class="descr-of-field">ИНН</div>
              </div>
              <div class="mr-3">
                <div class="value-of-field">{{ detailedItem.ogrn || "Не указан" }}</div>
                <div class="descr-of-field">ОГРН</div>
              </div>
              <div>
                <div class="value-of-field">{{ detailedItem.kpp || "Не указан" }}</div>
                <div class="descr-of-field">КПП</div>
              </div>
            </div>
          </div>
          
          <div class="details-group">
            <div class="value-of-field sm-value-of-field">{{ detailedItem.address || "Не указан" }}</div>
            <div class="descr-of-field">Юридический адрес</div>
          </div>

          <div class="details-group">
            <div class="value-of-field sm-value-of-field">{{ detailedItem.address_fact || "Не указан" }}</div>
            <div class="descr-of-field">Фактический адрес</div>
          </div>

          <div class="details-group">
            <div class="value-of-field">
              {{ bankNames == '' ? 'Не указаны' : `Добавлены реквизиты банков: ${bankNames}` }}
            </div>
            <div class="descr-of-field">Банковские реквизиты</div>
          </div>

          <div 
            v-if="detailedItem.bookmarked_comments && detailedItem.bookmarked_comments.length > 0"
            class="details-group bookmarked-comments-of-company"
          >
            <div class="value-of-field">
              <div v-for="item in detailedItem.bookmarked_comments" :key="item.id">
                <span v-html="cleanedComment(item.comment)"></span>
              </div>
            </div>
            <div class="descr-of-field">Отметки менеджеров о компании</div>
          </div>
          
          <div class="details-group">
            <div class="value-of-field">{{ (detailedItem.date_of_opening || "Не указан") | formattedDate }}</div>
            <div class="descr-of-field">Дата основания компании</div>
          </div>

          <div class="details-group">
            <div class="value-of-field">{{ detailedItem.year_certificate_of_residency || "Не указан" }} год</div>
            <div class="descr-of-field">Справка о резидентстве (актуальный год)</div>
          </div>

          <div class="details-group">
            <div class="value-of-field">{{ detailedItem.phones || "Не указаны" }}</div>
            <div class="descr-of-field">Телефоны компании</div>
          </div>

          <div class="details-group">
            <div class="value-of-field">{{ detailedItem.director || "Не указан" }}</div>
            <div class="descr-of-field">ФИО директора</div>
          </div>

          <div class="details-group">
            <div class="value-of-field">{{ detailedItem.type_director || "Не указано" }}</div>
            <div class="descr-of-field">В лице</div>
          </div>

          <div class="details-group" v-if="canShowSubCompanies(detailedItem.parent)">
            <div class="value-of-field">
              <tree-view
                :items="detailedItem.parent"
                :item-children="'parent'"
              >
                <template #item="{ item }">
                  <span
                      class="sidebar-link"
                      @click="openCompanySidebar(item.id)"
                  >
                      {{ item.name }}
                  </span>
                </template>
              </tree-view>              
            </div>
            <div class="descr-of-field">Родительская компания</div>
          </div>

          <div class="details-group" v-if="canShowSubCompanies(detailedItem.children)">
            <div class="value-of-field">
              <tree-view
                :items="detailedItem.children"
              >
                <template #item="{ item }">
                  <span
                      class="sidebar-link"
                      @click="openCompanySidebar(item.id)"
                  >
                      {{ item.name }}
                  </span>
                </template>
              </tree-view>           
            </div>
            <div class="descr-of-field">Дочерние компании</div>
          </div>
        </div>

        <div class="form-group col-md-6 bg-gray-right">
          <div class="details-group">
            <div class="value-of-field big-value-of-field">
              <template v-if="serviceNames == ''">
                <b-alert variant="danger" class="mb-0" show title="Укажите сегменты деятельности компании">Не указаны</b-alert>
              </template>
              <template v-else>
                <span v-html="serviceNames"></span>
              </template>
            </div>
            <div class="descr-of-field">Сегменты</div>
          </div>

          <div class="details-group">
            <div class="value-of-field big-value-of-field">
              <template v-if="specialFeaturesNames == ''">
                Не указаны
              </template>
              <template v-else>
                <span v-html="specialFeaturesNames"></span>
              </template>
            </div>
            <div class="descr-of-field">Специальные возможности</div>
          </div>

          <div class="details-group">
            <div class="value-of-field">
              <template v-if="countriesOfBranchesNames == ''">
                Не указаны
              </template>
              <template v-else>
                <span v-html="countriesOfBranchesNames"></span>
              </template>
            </div>
            <div class="descr-of-field">Страны регистрации филиалов и обособленных подразделений</div>
          </div>

          <div class="details-group">
            <div class="value-of-field">
              <template v-if="countriesOfRollingStockNames == ''">
                Не указаны
              </template>
              <template v-else>
                <span v-html="countriesOfRollingStockNames"></span>
              </template>
            </div>
            <div class="descr-of-field">Страны регистрации собственного подвижного состава</div>
          </div>

          <div class="details-group">
            <div class="value-of-field">
              <div class="table-document-correction">
                <div class="text-uppercase">
                  <div
                    v-for="(document, index) in listOfPriorityDocuments"
                    :key="document.id"
                  >
                    <template v-if="document.avaible">
                      <i class="bx bx-check text-success mr-2"></i>
                      {{ document.name }}
                    </template>
                    <template v-else>
                      <i class="bx bx-x text-danger mr-2"></i> {{ document.name }}
                    </template>
                  </div>
                </div>
                <!-- <tsoft-show-edit-documents
                  :companyId="detailedItem.id"
                  :referenceDocumentTypeIds="listOfPriorityIdsDocuments"
                  :requestDocuments="true"
                  :hideEmptyAlert="true"
                ></tsoft-show-edit-documents> -->
              </div>
            </div>
            <div class="descr-of-field">Требуемые документы</div>
          </div>

        </div>
      </div>

      <table class="table table-hover table-borderless table-fixed">
        <tbody>
          <tr v-if="detailedItem.sales_status == 'Не готов'">
            <td class="table-title-details">Последний статус отказа</td>
            <td>
              {{ detailedItem.decline_type ? detailedItem.decline_type.name : "Не указано" }}
            </td>
          </tr>
        </tbody>
      </table>
    </template>
  </div>
</template>

<script>
import { API_COMPANY } from "../../constants";
import TreeView from "../ui/TreeView.vue";
import { openCompanySidebar } from '../../mixins/openCompanySidebar';
import CompanyDadataCheckDetails from '@/components/companies/CompanyDadataCheckDetails.vue'

export default {
  props: {
    detailedItem: { type: Object, required: false },
  },
  components: {
    TreeView,
    CompanyDadataCheckDetails
  },
  metaInfo() {
    return {
      title: this.detailedItem.name,
    };
  },
  mixins: [openCompanySidebar],
  data() {
    return {
      changeCompany: API_COMPANY,
      dataOverlay: true,
      isOpenCheckDetails: false,
      listOfPriorityDocuments: [
        { id: 448, name: "Карта реквизитов", avaible: false },
        { id: 449, name: "Бухгалтерский баланс", avaible: false },
        { id: 450, name: "Финансовый отчет", avaible: false },
        { id: 451, name: "НДС 4-х кварталов", avaible: false },
        { id: 452, name: "1-й лист РСВ", avaible: false },
        { id: 453, name: "ИНН", avaible: false },
        { id: 454, name: "ОГРН", avaible: false },
        { id: 455, name: "Договор", avaible: false },
        { id: 979, name: "Справка о резидентстве на текущий год", avaible: false },
      ],
      seasonable: [],
    };
  },
  watch: {
    "detailedItem.documents": {
        handler(documents) {
          this.checkDocsAvailability();
        },
        deep: true
    },
    info(value) {
      this.dataOverlay = !!!value;
    },
  },
  computed: {
    listOfPriorityIdsDocuments() {
      return this.listOfPriorityDocuments.map(item => item.id);
    },

    seasonable_name() {
      let name = undefined;
      if (typeof this.getSeasonableName === 'function') {
          const result = this.getSeasonableName();
          if (result && result.name) {
              name = result.name;
          }
      }
      if (!name) {
          name = `${this.detailedItem.seasonable} мес.`;
      }

      return name;
    },

    bankNames() {
      return this.detailedItem.payment_details.map(detail => detail.bank_name).join(", ");
    },

    serviceNames() {
      return this.detailedItem.services.map(detail => detail.name).join("<br>");
    },

    specialFeaturesNames() {
      return this.detailedItem.special_features.map(detail => detail.name).join("<br>");
    },

    countriesOfBranchesNames() {
      return this.detailedItem.countries_of_branches.map(detail => detail.name).join(", ");
    },

    countriesOfRollingStockNames() {
      return this.detailedItem.countries_of_rolling_stock.map(detail => detail.name).join(", ");
    },
  },

  mounted() {
    this.updateListOfPriorityDocuments();
    this.getConst();
  },

  methods: {
    getConst() {
      api.call("get", `${API_COMPANY}/get-const`, this.editedItemLocal).then(({data}) => {
          this.seasonable = data.seasonable ?? [];
      }).catch((response) => {

      })
    },

    canShowSubCompanies(items) {
      return items && items.length;
    },

    updateListOfPriorityDocuments() {
      let listOfSprecialFeatures = this.detailedItem.special_features.map(detail => detail.name);
      let listOfAllDocs = this.$store.state.referencePropertiesList.grouped[34];

      listOfAllDocs.forEach((doc) => {
        if (listOfSprecialFeatures.includes(doc.name)) {
          this.listOfPriorityDocuments.push({ 
            id: doc.id, name: doc.name, avaible: false 
          });
        }
      })

      this.checkDocsAvailability();
    },
    checkDocsAvailability() {
      this.detailedItem.documents.forEach((doc, index) => {
        if (this.listOfPriorityIdsDocuments.includes(doc.reference_document_type_id)) {
          this.listOfPriorityDocuments = this.listOfPriorityDocuments.map(priorityDoc => {
            if (priorityDoc.id == doc.reference_document_type_id) {
              priorityDoc.avaible = true;
            }
            return priorityDoc
          });
        }
      });
    },
    cleanedComment(comment) {
      return comment.replace(/<p><br><\/p>|<p><br\/><\/p>|<p><\/p>/g, '');
    }
  },
};
</script>

<style scoped>
.details-group.bookmarked-comments-of-company {
  background: #ff000024;
}
.bookmarked-comments-of-company p {
  margin-bottom: 5px;
}
</style>